import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "px-2 px-md-0"
}
const _hoisted_2 = { class: "element-box mx-auto w-100 w-lg-80" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center mb-4 pb-3 border-bottom gap-3" }
const _hoisted_5 = { class: "fw-bold text-secondary mb-2 mb-md-0 d-flex align-items-center" }
const _hoisted_6 = { class: "text-center my-2 my-md-0" }
const _hoisted_7 = { class: "text-danger fw-bold pulse-animation small-mobile-text" }
const _hoisted_8 = { class: "text-center text-md-end" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "row mb-3" }
const _hoisted_11 = { class: "col-12 col-md-6 mb-2" }
const _hoisted_12 = { class: "h5 fw-normal text-dark d-block mt-1" }
const _hoisted_13 = { class: "border-top pt-3 mt-3" }
const _hoisted_14 = { class: "fw-bold text-secondary mb-3 d-flex align-items-center" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-6 col-sm-4 col-md-3 mb-3" }
const _hoisted_17 = { class: "text-dark font-weight-medium" }
const _hoisted_18 = { class: "col-6 col-sm-4 col-md-3 mb-3" }
const _hoisted_19 = { class: "text-dark font-weight-medium" }
const _hoisted_20 = { class: "table-responsive mt-4 rounded shadow-sm bg-white" }
const _hoisted_21 = { class: "table table-striped align-middle mb-0" }
const _hoisted_22 = { class: "fw-bold align-middle text-nowrap" }
const _hoisted_23 = { class: "align-middle text-nowrap" }
const _hoisted_24 = { class: "align-middle text-nowrap" }
const _hoisted_25 = { class: "align-middle text-nowrap" }
const _hoisted_26 = { class: "text-end align-middle text-nowrap" }
const _hoisted_27 = { class: "text-center align-middle" }
const _hoisted_28 = {
  key: 0,
  class: "badge bg-soft-danger text-danger p-2",
  style: {"font-size":"11px","white-space":"normal"}
}
const _hoisted_29 = {
  key: 1,
  class: "signature-img-container"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "text-end align-middle text-nowrap" }
const _hoisted_32 = ["onClick"]

import portalPrivateCoachingService from '@/api/Portal/PrivateCoaching';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import {onMounted, ref, watch} from 'vue';
import {useRoute} from 'vue-router';
import RemoteDigitalSignatureForm
  from "@/views/App/Portal/PrivateCoaching/RemoteDigitalSignature/RemoteDigitalSignatureForm.vue";

interface ICompany {
  color: string;
  logo: string,
}

interface IUnemployed {
  firstName: string;
  lastName: string,
  address: string,
  city: string,
  zip: string,
  aaNumber: string,
  insuranceNumber: string,
  email: string,
  phone: string,
}

interface ICalculatedUnits {
  unitsDone: number;
  maxUnits: number;
}

interface ICoaching {
  startDate: string;
  endDate: string;
  calculatedUnits: ICalculatedUnits | null;
}

export interface IMeeting {
  id: number;
  termin: string;
  startTime: string;
  endTime: string;
  presenceTranslation: string;
  units: number;
  moduleName: string;
  digitalSignature: string | null;
  homeVisit: boolean;
  meetingType: string;
  coach?: {
    fullName: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoteMeetings',
  setup(__props) {

const route = useRoute();

const company = ref<ICompany | null>(null);
const unemployed = ref<IUnemployed | null>(null);
const coaching = ref<ICoaching | null>(null);
const meetings = ref<IMeeting[]>([])
const meetingId = ref<number | null>(null);
const meetingType = ref<string>("")

const tokenExpiresAt = ref('')
const isLoaded = ref(false);
const showDigitalSignatureModal = ref(false);
const submitForm = ref(false);
const token = route.params.token as string;



watch(submitForm, () => {
  meetingId.value = null;
  showDigitalSignatureModal.value = false;
  getData();
});

async function getData() {
  try {
    const {data} = await portalPrivateCoachingService.getRemoteMeetings(token);
    coaching.value = data.data?.coaching
    unemployed.value = data.data?.unemployed
    company.value = data.data?.company
    tokenExpiresAt.value = data.data?.expiresAt
    meetings.value = data.data?.meetings
  } catch (error) {
    await ErrorToast(error);
  }
}

function handleDigitalSignatureModal(id: number, type: string) {
  CloseToast();
  meetingId.value = id;
  meetingType.value = type;
  showDigitalSignatureModal.value = true;
}

onMounted(async () => {
  await getData()
  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: "row m-0 p-3 p-md-4 bg-white rounded shadow-sm",
                style: _normalizeStyle({
              'border': `1px solid ${company.value?.color} !important`,
              'border-top': `3px solid ${company.value?.color} !important`
              })
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h5", _hoisted_5, [
                      _createElementVNode("i", {
                        class: "os-icon os-icon-user me-2",
                        style: _normalizeStyle({ color: company.value?.color })
                      }, null, 4),
                      _cache[2] || (_cache[2] = _createElementVNode("span", null, "Benutzerdaten", -1))
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "os-icon os-icon-clock me-1" }, null, -1)),
                        _createTextVNode("Link gültig bis: " + _toDisplayString(tokenExpiresAt.value || 'Keine Angaben'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: company.value?.logo,
                        alt: "Logo",
                        class: "img-fluid",
                        style: {"max-height":"45px","object-fit":"contain"}
                      }, null, 8, _hoisted_9)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[4] || (_cache[4] = _createElementVNode("small", { class: "text-muted d-block text-uppercase fw-bold tracking-wider" }, " Vor- und Nachname ", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(unemployed.value?.firstName) + " " + _toDisplayString(unemployed.value?.lastName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h6", _hoisted_14, [
                      _createElementVNode("i", {
                        class: "os-icon os-icon-trending-up me-2",
                        style: _normalizeStyle({ color: company.value?.color })
                      }, null, 4),
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Coaching-Daten", -1))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted d-block text-uppercase fw-bold tracking-wider" }, "Startdatum", -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(coaching.value?.startDate || 'Keine Angaben'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _cache[7] || (_cache[7] = _createElementVNode("small", { class: "text-muted d-block text-uppercase fw-bold tracking-wider" }, "Enddatum", -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(coaching.value?.endDate || 'Keine Angaben'), 1)
                      ])
                    ])
                  ])
                ])
              ], 4),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("table", _hoisted_21, [
                  _createElementVNode("thead", {
                    style: _normalizeStyle({
                    borderBottom: `3px solid ${company.value?.color}`,
                    color: 'black'
                })
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", {
                        class: "py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Termin"),
                      _createElementVNode("th", {
                        class: "py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Startzeit"),
                      _createElementVNode("th", {
                        class: "py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Endzeit"),
                      _createElementVNode("th", {
                        class: "py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Anwesenheit"),
                      _createElementVNode("th", {
                        class: "text-end py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Einheiten"),
                      _createElementVNode("th", {
                        class: "text-center py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Unterschrift"),
                      _createElementVNode("th", {
                        class: "text-end py-3 px-2 text-nowrap",
                        style: {"font-size":"12px"}
                      }, "Aktion")
                    ], -1)
                  ]))], 4),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meetings.value, (meeting) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: meeting.id
                      }, [
                        _createElementVNode("td", _hoisted_22, _toDisplayString(meeting?.termin), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(meeting?.startTime), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(meeting?.endTime), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(meeting?.presenceTranslation), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(meeting?.units), 1),
                        _createElementVNode("td", _hoisted_27, [
                          (!meeting.digitalSignature)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, " Fehlende Digitale Unterschrift "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("img", {
                                  src: meeting.digitalSignature,
                                  alt: "Unterschrift",
                                  class: "img-fluid signature-img"
                                }, null, 8, _hoisted_30)
                              ]))
                        ]),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-sm px-3 py-2 d-inline-flex align-items-center",
                            onClick: _withModifiers(($event: any) => (handleDigitalSignatureModal(
                            meeting?.id,
                            meeting.meetingType
                            )), ["stop"])
                          }, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "os-icon os-icon-edit me-1" }, null, -1),
                            _createElementVNode("span", null, "Unterschreiben", -1)
                          ]))], 8, _hoisted_32)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createVNode(Modal, {
              modelValue: showDigitalSignatureModal.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDigitalSignatureModal).value = $event)),
              title: "Digitale Unterschrift",
              "hide-cancel": true,
              "button-label": _ctx.$t('general.button.save'),
              sizeModal: "modal-md",
              "hide-footer": true,
              classFooter: "justify-content-center"
            }, {
              default: _withCtx(() => [
                _createVNode(RemoteDigitalSignatureForm, {
                  token: _unref(token),
                  meetingId: meetingId.value,
                  meetingType: meetingType.value,
                  submitForm: submitForm.value,
                  "onUpdate:submitForm": _cache[0] || (_cache[0] = ($event: any) => ((submitForm).value = $event))
                }, null, 8, ["token", "meetingId", "meetingType", "submitForm"])
              ]),
              _: 1
            }, 8, ["modelValue", "button-label"])
          ]))
    ]),
    _: 1
  }))
}
}

})